import { Component, ElementRef, OnInit, QueryList, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { MatTable } from '@angular/material/table';

class CostPerParent {
  type: string;
  parentName: string;
  quantity: number;
  unitcost: number;
  totalPerLine: number;
}

@Component({
    selector: 'app-budget',
    templateUrl: './budget.component.html',
    styleUrls: ['./budget.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BudgetComponent implements OnInit {

  // @ViewChild(MatTable) table: MatTable<any>;
  @ViewChildren(MatTable) tables!: QueryList<MatTable<any>>;
  displayedColumns = ['type', 'quantity', 'unitcost', 'totalPerline'];
  budget: CostPerParent[][] = [];

  constructor(private elRef: ElementRef) { }

  ngOnInit(): void {
    let zone1: CostPerParent[] = [];

    const ccp = new CostPerParent();
    ccp.parentName = 'Zone A';
    ccp.type = 'Deplacement';
    ccp.quantity = 2;
    ccp.unitcost = 50;

    const ccp1 = new CostPerParent();
    ccp1.parentName = 'Zone A';
    ccp1.type = 'META';
    ccp1.quantity = 3;
    ccp1.unitcost = 70;

    zone1.push(ccp);
    zone1.push(ccp1);

    let zone2: CostPerParent[] = [];
    const ccp2 = new CostPerParent();
    ccp2.parentName = 'Zone B';
    ccp2.type = 'Deplacement';
    ccp2.quantity = 33;
    ccp2.unitcost = 5;
    zone2.push(ccp2);

    let zone3: CostPerParent[] = [];
    const ccp3 = new CostPerParent();
    ccp3.parentName = 'Zone C';
    ccp3.type = 'Deplacement';
    ccp3.quantity = 33;
    ccp3.unitcost = 5;
    zone3.push(ccp3);

    this.budget.push(zone1);
    this.budget.push(zone2);
    this.budget.push(zone3);
  }

  getParentName(c: CostPerParent[]) {
    return c.map(x => x.parentName).reduce(y => y);
  }

  /** Gets the total cost of all transactions. */
  getTotalCost(c: CostPerParent[]) {
    return c.map(t => t.quantity * t.unitcost).reduce((acc, value) => acc + value, 0);
  }

  getGrandTotal() {
    let sum = 0;
    this.budget.forEach(x => {
      sum += x.map(t => t.quantity * t.unitcost).reduce((acc, value) => acc + value, 0);
    });
    return sum;
  }

  addPump(c: CostPerParent[], index: number) {
    // const table = this.elRef.nativeElement.querySelector(`#table${index}`);
    // const tablee = document.getElementsByTagName(`#table${index}`);

    if (c.find(x => x.type === 'Pompe sur batterie')) {
      const ccp = c.find(x => x.type === 'Pompe sur batterie');
      ccp.quantity++;
    } else {

      const ccp = new CostPerParent();
      ccp.parentName = c.reduce(x => x).parentName;
      ccp.type = 'Pompe sur batterie';
      ccp.quantity = 1;
      ccp.unitcost = 123;
      c.push(ccp);
      // (table as MatTable<any>).renderRows();
      // this.table.renderRows();
      this.tables.forEach(x => x.renderRows())
    }
  }
}
